import getAddToCalendarButton from './getAddToCalendarButton';
import getEditButtons from './getEditButtons';
import getOpenInGoogleButton from './getOpenInGoogleButton';
import getSaveToCloudButton from './getSaveToCloudButton';
import getOpenCloudyDocumentInNewTabButton from './getOpenCloudyDocumentInNewTabButton';
import getTextPreviewEncodingOptions from './getTextPreviewEncodingOptions';
import { SxSStore } from 'owa-sxs-store';
import {
    getDefaultPreviewPaneCommandBarItems,
    PreviewPaneCommandBarItem,
} from 'owa-sxs/lib/utils/PreviewPaneCommandBarButton';

export default function getCommandBarButtonsForMail(
    sxsStore: SxSStore
): PreviewPaneCommandBarItem[] {
    return [
        ...getEditButtons(sxsStore),
        getAddToCalendarButton(sxsStore),
        getOpenInGoogleButton(sxsStore),
        ...getDefaultPreviewPaneCommandBarItems(),
        getSaveToCloudButton(sxsStore),
        getOpenCloudyDocumentInNewTabButton(sxsStore),
        getTextPreviewEncodingOptions(sxsStore),
    ];
}
